import React from 'react'
import georisques from 'assets/pictures/georisques.png'
import logoInsee from 'assets/pictures/logo-insee.png'
import eaufrance from 'assets/pictures/logos/eaufrance.jpg'
import googleMap from 'assets/pictures/logos/googleMap.png'
import ApplicationConf from 'conf/ApplicationConf'
import { push } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import HydrometryAction from 'hydrometry/actions/HydrometryAction'
import InstallationAction from 'installation/actions/InstallationAction'
import { template } from 'lodash'
import PiezometryAction from 'piezometry/actions/PiezometryAction'
import PluviometryAction from 'pluviometry/actions/PluviometryAction'
import ProductionUnitAction from 'productionUnit/actions/ProductionUnitAction'
import QualityAction from 'quality/actions/QualityAction'
import { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import useActions from 'utils/customHook/useActions'
import useTitle from 'utils/customHook/useTitle'
import { getValidCodeInput, getValidNameInsee } from 'utils/StringUtil'
import { v4 as uuidv4 } from 'uuid'
import Input from '../../../../components/forms/Input'
import NumberField from '../../../../components/forms/NumberField'
import Select from '../../../../components/forms/Select'
import SieauAction from '../../../../components/sieau/SieauAction'
import Textarea from '../../../../components/forms/Textarea'
import {
    eaufranceCityLink,
    georisquesCityLink,
    googleMapsSearchPath,
    inseeCityLink,
} from '../../../../conf/SieauConstants'
import {
    PATH_REFERENCIAL,
    PATH_REFERENCIAL_CITY,
    PATH_REFERENCIAL_CITY_LINK,
    PATH_REFERENCIAL_CITY_NEW,
} from '../../../../home/constants/RouteConstants'
import { getUser } from '../../../../utils/SettingUtils'
import { getSandreList } from '../../../../utils/StoreUtils'
import ReferencialAction from '../../../action/ReferencialAction'
import { FR, SANDRE } from '../../../constants/ReferencialConstants'
import CountryAction from '../../country/actions/CountryAction'
import DeleteModal from '../../DeleteModal'
import ReplaceModal from '../../ReplaceModal'
import CityAction from '../actions/CityAction'
import CityDto from '../dto/CityDto'
import { useParams } from 'react-router'
import { Box, Card, CardContent, Grid2 } from '@mui/material'
import { CardTable } from 'components/datatable/NewTable'
import { mainBlue } from 'utils/constants/ColorTheme'

const typeCedex = { headers: ['cedex'] }
const typeCityHisto = { headers: ['cityCode', 'name'] }

const CityApp = () => {
    const { code } = useParams()

    const {
        cityProps,
        cities,
        sandreCodes,
        cityCedex,
        countries,
        citiesHisto,
        qualitometersLight,
        piezometersLight,
        installationsLight,
        productionUnits,
        pluviometers,
        hydrometricStations,
        contacts,
        contributors,
    } = useSelector(store => ({
        cityProps: store.CityReducer.city,
        cities: store.CityReducer.cities,
        sandreCodes: store.ReferencialReducer.sandreCodes,
        cityCedex: store.CityReducer.cityCedex,
        countries: store.CountryReducer.countries,
        citiesHisto: store.CityReducer.citiesHisto,
        qualitometersLight: store.QualityReducer.qualitometersLight,
        piezometersLight: store.PiezometryReducer.piezometersLight,
        installationsLight: store.InstallationReducer.installationsLight,
        productionUnits: store.ProductionUnitReducer.productionUnits,
        pluviometers: store.PluviometryReducer.pluviometers,
        hydrometricStations: store.HydrometryReducer.hydrometricStations,
        contacts: store.ContactReducer.contacts,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const [city, setCity] = useState(new CityDto({}))
    const [isEditMode, setIsEditMode] = useState(false)

    const getCityLinks = () => {
        if ((!cityProps.countryCode || cityProps.countryCode === FR) && cityProps.code) {
            return [{
                href: template(inseeCityLink)({ code: cityProps.code, lowercaseName: getValidNameInsee(cityProps.name) || '' }),
                img: logoInsee,
                label: i18n.insee.toUpperCase(),
            }, {
                href: georisquesCityLink + cityProps.code,
                img: georisques,
                label: i18n.georisques.toUpperCase(),
            }, {
                href: eaufranceCityLink + cityProps.code,
                img: eaufrance,
                label: i18n.eaufrance.toUpperCase(),
            }, {
                href: googleMapsSearchPath + cityProps.code,
                img: googleMap,
                label: 'Google Maps',
            }]
        }
        return []
    }

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(HomeAction.setHelpLink('', ''))

        if (code !== 'new') {
            dispatch(CityAction.fetchCity(code))
            setIsEditMode(false)
        } else {
            setIsEditMode(true)
        }

        if (!sandreCodes.length) {
            dispatch(ReferencialAction.fetchSandreCodes())
        }
        if (!cityCedex.length) {
            dispatch(CityAction.fetchCityCedex())
        }
        if (!countries.length) {
            dispatch(CountryAction.fetchCountries())
        }
        if (!citiesHisto.length) {
            dispatch(CityAction.fetchCitiesHisto())
        }
        if (!qualitometersLight.length) {
            dispatch(QualityAction.fetchQualitometersLight())
        }
        if (!piezometersLight.length) {
            dispatch(PiezometryAction.fetchPiezometersLight())
        }
        if (!installationsLight.length) {
            dispatch(InstallationAction.fetchInstallationsLight())
        }
        if (!productionUnits.length) {
            dispatch(ProductionUnitAction.fetchProductionUnits())
        }
        if (!pluviometers.length) {
            dispatch(PluviometryAction.fetchPluviometers())
        }
        if (!hydrometricStations.length) {
            dispatch(HydrometryAction.fetchHydrometricStations())
        }
        if (!contacts.length) {
            dispatch(ContactAction.fetchContacts())
        }
        if (!contributors.length) {
            dispatch(ContributorAction.fetchContributors())
        }
    }, [code])

    useEffect(() => {
        setCity(cityProps)
    }, [cityProps])

    useEffect(() => () => dispatch(CityAction.resetCity()), [])

    const checkCode = (callback = () => {}) => {
        const existCode = cities.find(c => c.code === city.code)
        if (existCode) {
            dispatch(ToastrAction.error(i18n.codeAlreadyExists))
        } else if (!city.code && !city.code.length <= 1) {
            dispatch(ToastrAction.error(i18n.thanksToEnterCode))
        } else {
            callback()
        }
    }

    const isConsultant = useMemo(() => getUser().consultant === '1', [])

    useActions(() => {
        if (isConsultant) {
            return {}
        }
        const links = getCityLinks()
        const isNewActions = code === 'new' && (!cityProps || !cityProps.code)
        const actions = (() => {
            if (isNewActions) {
                return {
                    save: () => checkCode(() => {
                        dispatch(CityAction.createCity(city))
                        dispatch(CityAction.fetchCities())
                        setIsEditMode(false)
                    }),
                    cancel: () => {
                        dispatch(push(PATH_REFERENCIAL_CITY))
                        setIsEditMode(false)
                    },
                }
            }
            if (isEditMode) {
                return {
                    save: () => {
                        dispatch(CityAction.updateCity({ ...city, code: city.code.toString() }, city.code))
                        dispatch(CityAction.fetchCities())
                        setIsEditMode(false)
                    },
                    cancel: () => {
                        setCity(cityProps)
                        setIsEditMode(false)
                    },
                }
            }
            return {
                edit: () => {
                    setIsEditMode(true)
                },
                deleteCheck: () => {
                    dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.cityCountDelete(code)))
                    const id = uuidv4()
                    const popup = {
                        id,
                        content: <DeleteModal
                            onDelete={() => dispatch(CityAction.deleteCity(city.code))}
                        />,
                        dismissible: false,
                    }
                    dispatch(SieauAction.setPopup(popup))
                },
                replace: () => {
                    dispatch(ReferencialAction.fetchCheckDelete(ApplicationConf.referencial.cityCountDelete(code)))
                    const id = uuidv4()
                    const popup = {
                        id,
                        content: <ReplaceModal
                            elements={ cities }
                            title={`${i18n.city} [${city.code}]`}
                            label={i18n.city}
                            onReplace={ (newCode) => dispatch(CityAction.replaceCity(city.code, newCode.code)) }
                        />,
                        dismissible: false,
                    }
                    dispatch(SieauAction.setPopup(popup))
                },
            }
        })()
        return (!isNewActions && !isEditMode && links.length > 0) ? { ...actions, links } : actions
    }, [isConsultant, code, cityProps, city, isEditMode])

    useTitle(() => {
        if (code === 'new') {
            return [
                {
                    title: i18n.referencials,
                    href: PATH_REFERENCIAL,
                },
                {
                    title: i18n.towns,
                    href: PATH_REFERENCIAL_CITY,
                },
                {
                    title: i18n.new,
                    href: PATH_REFERENCIAL_CITY_NEW,
                },
            ]
        }
        return [
            {
                title: i18n.referencials,
                href: PATH_REFERENCIAL,
            },
            {
                title: i18n.towns,
                href: PATH_REFERENCIAL_CITY,
            },
            {
                title: code + (cityProps.name ? ` - ${cityProps.name}` : ''),
                href: PATH_REFERENCIAL_CITY_LINK + code,
            },
        ]
    }, [code, cityProps])

    const disabled = useMemo(() => ({
        active: isEditMode,
        disabled: !isEditMode,
    }), [isEditMode])

    const dataCedex = useMemo(() => cityCedex.filter(cc => cc.cityCode === city.code), [city.code, cityCedex])
    const dataCityHisto = useMemo(() => citiesHisto.filter(ch => ch.cityAttachmentCode === city.code), [citiesHisto, city.code])

    return (
        <Box margin='10px 10px 10px 0'>
            <Grid2 container spacing={1}>
                <Grid2 container size={6} direction='column' spacing={1}>
                    <Card>
                        <CardContent>
                            <Grid2 container spacing={1}>
                                <Grid2 size={3}>
                                    <Input
                                        title={ i18n.code }
                                        value={ city.code }
                                        onChange={ newCode => setCity({ ...city, code: getValidCodeInput(newCode) }) }
                                        maxLength={ 12 }
                                        disabled={ code !== 'new' }
                                    />

                                </Grid2>
                                <Grid2 size={9}>
                                    <Input
                                        title={ i18n.name }
                                        value={ city.name }
                                        onChange={ name => setCity({ ...city, name }) }
                                        maxLength={ 35 }
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <Select
                                        label={ i18n.country }
                                        value={ city.countryCode }
                                        options={ countries }
                                        keyValue='countryCode'
                                        nullLabel='&nbsp;'
                                        onChange={ countryCode => setCity({ ...city, countryCode }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <Select
                                        options={ getSandreList(sandreCodes, SANDRE.COMMUNES_SITUATION) }
                                        label={ i18n.situation }
                                        onChange={ situation => setCity({ ...city, situation }) }
                                        value={ parseInt(city.situation) }
                                        nullLabel='&nbsp;'
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <Select
                                        options={ getSandreList(sandreCodes, 'PREL_AGRI.SECTEUR_CLIMATIQUE') }
                                        label={ i18n.climateSector }
                                        onChange={ climateSector => setCity({ ...city, climateSector }) }
                                        value={ parseInt(city.climateSector) }
                                        nullLabel='&nbsp;'
                                        keyLabel='referenceWithLabel'
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={12}>
                                    <CardTable
                                        title={ i18n.cedexList }
                                        color={mainBlue}
                                        row={ dataCedex }
                                        headers={typeCedex.headers}
                                        headersLabel={{ cedex: i18n.cedexCode }}
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                    <Card>
                        <CardContent>
                            <Grid2 container spacing={1}>
                                <Grid2 size={6}>
                                    <Input
                                        title={ i18n.email }
                                        value={ city.email }
                                        onChange={ email => setCity({ ...city, email }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <Input
                                        title={ i18n.phone }
                                        value={ city.phone }
                                        onChange={ phone => setCity({ ...city, phone }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                </Grid2>
                <Grid2 container size={6} direction='column' spacing={1}>
                    <Card>
                        <CardContent>
                            <Grid2 container spacing={1}>
                                <Grid2 size={6}>
                                    <NumberField
                                        title={ i18n.area }
                                        value={ city.area }
                                        onChange={ area => setCity({ ...city, area }) }
                                        { ...disabled }
                                        floatValue
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <NumberField
                                        title={ i18n.population }
                                        value={ city.population }
                                        onChange={ population => setCity({ ...city, population }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <NumberField
                                        floatValue
                                        title={ i18n.x }
                                        value={ city.x }
                                        onChange={ x => setCity({ ...city, x }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <NumberField
                                        floatValue
                                        title={ i18n.y }
                                        value={ city.y }
                                        onChange={ y => setCity({ ...city, y }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={6}>
                                    <Select
                                        options={ getSandreList(sandreCodes, SANDRE.PROJECTION) }
                                        label={ i18n.projection }
                                        onChange={ projection => setCity({ ...city, projection }) }
                                        value={ city.projection }
                                        nullLabel='&nbsp;'
                                        { ...disabled }
                                    />
                                </Grid2>
                                <Grid2 size={12}>
                                    <Textarea
                                        title={ i18n.km_polygon }
                                        value={ city.kml }
                                        onChange={kml => setCity({ ...city, kml }) }
                                        { ...disabled }
                                    />
                                </Grid2>
                            </Grid2>
                        </CardContent>
                    </Card>
                    <CardTable
                        title={ i18n.associatedCities }
                        rows={ dataCityHisto }
                        headers={typeCityHisto.headers}
                    />
                </Grid2>
            </Grid2>
        </Box>
    )
}

export default CityApp
